<template>
  <div id="app" class="body-color">
    <Header2 :menu="menu" @onLoadProducts="loadProductsInCat" v-if="!isInMaintenance" />

    <router-view></router-view>
    <FloatingButton v-if="isMatrix" :phone="'523481133967'"></FloatingButton>
  </div>
</template>

<script>
import toastr from "toastr";

import {
  ERROR_MSG,
  ADD_PRODUCT_SUCCESS,
  UPDATE_PRODUCT_SUCCESS,
  REMOVE_PRODUCT_SUCCESS,
} from "./store/mutation-types";

import Header2 from "./components/app/Header2";
import CategoryDropdown from "./components/app/CategoryDropdown";
import FloatingButton from "./components/app/FloatingButton";

export default {
  name: "app",
  data() {
    return {
      cartItems: this.$store.state.cart,
    };
  },
  created: async function () {
    this.$store.subscribe((mutation) => {
      if (mutation.payload) {
        switch (mutation.type) {
          case "OK_MSG":
            toastr.success(mutation.payload.content, mutation.payload.title);
            break;
          case "INFO_MSG":
            toastr.info(mutation.payload.content, mutation.payload.title);
            break;
          case "WAR_MSG":
            toastr.warning(mutation.payload.content, mutation.payload.title);
            break;
          case ERROR_MSG:
            toastr.error(mutation.payload.content, mutation.payload.title, {
              timeOut: 10000,
            });
            break;
          case ADD_PRODUCT_SUCCESS:
            toastr.success("Producto guardado.", "Correcto!");
            break;
          case UPDATE_PRODUCT_SUCCESS:
            toastr.success("Actualización completa.", "Correcto!");
            break;
          case REMOVE_PRODUCT_SUCCESS:
            toastr.warning("Producto elminado.", "Eliminado!");
            break;
        }
      }
    });
    await this.$store.dispatch("application/loadAppSettings");
    await this.$store.dispatch("prices/loadPrices");
    await this.$store.dispatch("brands/loadBrands");
    await this.$store.dispatch("labels/loadLabels");

    const maintenance = this.$store.getters["application/isInMaintenance"];
    const canSell = this.$store.getters["application/canSell"];

    if (maintenance) {
      this.$router.push({ name: "Maintenance" });
    } else if (canSell) {
      const resp = await this.$store.dispatch("categories/loadCategories");

      this.$store.dispatch("cart/load");

      const { category, brand } = this.$route.query;

      if (category || brand) {
        const payload = {
          category: parseInt(category) || null,
          brand: brand,
        };

        await this.loadProductsInCat(payload);
      } else {
        this.$store
          .dispatch("auth/loadCustomer")
          .then(() => {})
          .catch((err) => {
            this.$router.push({ name: "Home" }).catch(() => {});
          });
      }
    } else {
      const resp = await this.$store.dispatch("categories/loadCategories");
      this.$router.push({ name: "Home" }).catch(() => {});
    }
  },
  computed: {
    isMatrix() {
      return this.$store.getters["application/isMatrix"];
    },
    showLoader() {
      return this.$store.state.showLoader;
    },
    isInMaintenance: function () {
      return this.$store.getters["application/isInMaintenance"];
    },
    categories: function () {
      return this.$store.getters["categories/getTree"];
    },
    menu: function () {
      return this.categories.map((cat) => {
        return {
          title: cat.label,
          element: "a",
          dropdown: cat.label,
          content: CategoryDropdown,
          data: cat,
          attributes: {
            class: ["item", cat.blink ? cat.blinkClass : ""],
          },
        };
      });
    },
  },
  methods: {
    loadProductsInCat: async function (payload) {
      this.scrollToTop();
      await this.$store.dispatch("products/loadProductsByCategory", payload);
      this.setQuery(payload);
    },
    scrollToTop() {
      window.scrollTo(50, 40);
    },
    setQuery: function (query) {
      let obj = {};

      if (query) {
        obj = Object.assign({}, this.$route.query);

        Object.keys(query).forEach((key) => {
          let value = query[key];
          if (value) {
            obj[key] = value;
          } else {
            delete obj[key];
          }
        });
      }

      if (this.$route.name === "Home") {
        this.$router
          .replace({
            ...this.$router.currentRoute,
            query: obj,
          })
          .catch(() => {});
      } else {
        this.$router.push({ name: "Home", query: obj }).catch(() => {});
      }
    },
  },
  components: {
    Header2,
    FloatingButton,
  },
};
</script>

<style>
body {
  height: calc(100vh - 150px);
}

.overlay {
  background: rgba(255, 255, 255, 0.6);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.loading-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translateX(-50%) translateY(-50%);
  -moz-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
}

.dot {
  background: black;
  border-radius: 100%;
  color: white;
  height: 8px;
  line-height: 8px;
  text-align: center;
  width: 8px;
}

.dotOne {
  -webkit-animation: dotOneKeyframes 5s ease infinite;
  background: #f9e610;
  position: absolute;
  top: 0;
  left: 0;
}

.dotTwo {
  -webkit-animation: dotTwoKeyframes 5s ease 0.4166666666666s infinite;
  background: #efdb06;
  position: absolute;
  top: 0;
  left: 14px;
}

.dotThree {
  -webkit-animation: dotThreeKeyframes 5s ease 0.83333333333s infinite;
  background: #dbc906;
  position: absolute;
  top: 14px;
  left: 14px;
}

@-webkit-keyframes dotOneKeyframes {
  0% {
    top: 0;
    left: 0;
  }
  8.3333333333% {
    top: 14px;
    left: 0;
  }
  16.6666666666% {
  }
  25% {
    top: 14px;
    left: 0;
  }
  33.3333333333% {
    top: 14px;
    left: 14px;
  }
  41.6666666666% {
  }
  50% {
    top: 14px;
    left: 14px;
  }
  58.3333333333% {
    top: 0;
    left: 14px;
  }
  66.6666666666% {
  }
  75% {
    top: 0;
    left: 14px;
  }
  83.3333333333% {
    top: 0;
    left: 0;
  }
  91.6666666666% {
  }
  100% {
  }
}

@-webkit-keyframes dotTwoKeyframes {
  0% {
    top: 0;
    left: 14px;
  }
  8.3333333333% {
    top: 0;
    left: 0;
  }
  16.6666666666% {
  }
  25% {
    top: 0;
    left: 0;
  }
  33.3333333333% {
    top: 14px;
    left: 0;
  }
  41.6666666666% {
  }
  50% {
    top: 14px;
    left: 0;
  }
  58.3333333333% {
    top: 14px;
    left: 14px;
  }
  66.6666666666% {
  }
  75% {
    top: 14px;
    left: 14px;
  }
  83.3333333333% {
    top: 0;
    left: 14px;
  }
  91.6666666666% {
  }
  100% {
  }
}

@-webkit-keyframes dotThreeKeyframes {
  0% {
    top: 14px;
    left: 14px;
  }
  8.3333333333% {
    top: 0;
    left: 14px;
  }
  16.6666666666% {
  }
  25% {
    top: 0;
    left: 14px;
  }
  33.3333333333% {
    top: 0;
    left: 0;
  }
  41.6666666666% {
  }
  50% {
    top: 0;
    left: 0;
  }
  58.3333333333% {
    top: 14px;
    left: 0;
  }
  66.6666666666% {
  }
  75% {
    top: 14px;
    left: 0;
  }
  83.3333333333% {
    top: 14px;
    left: 14px;
  }
  91.6666666666% {
  }
  100% {
  }
}
</style>
